import AdminTextInput from 'components/atoms/adminTextInput';
import RectangleImageButton from 'components/atoms/rectangleImageButton';
import {useTheme} from 'contexts/ThemeContext';
import {PersonalData} from 'models/Admin';
import React from 'react';
import {ListRenderItemInfo, View} from 'react-native';
import strings from 'translations/index.web';
import styleSheet from './styles';
import constants from '../../../constants';
import { observer } from 'mobx-react';

export interface ContactDataCell {
  itemProps: ListRenderItemInfo<PersonalData>;
  onPressDelete: (deletable: PersonalData) => void;
  onFieldEdit: (
    text: string,
    index: number,
    fieldName: string,
  ) => void;
}

const ContactDataCell = observer((props: ContactDataCell) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const {TEXTFIELD_TYPES} = constants;

  return (
    <View style={styles.container}>
      <AdminTextInput
        title={strings.admin.firstName}
        placeholder={strings.admin.firstName}
        value={props.itemProps.item.name}
        onChangeText={newValue => {
          props.onFieldEdit(
            newValue,
            props.itemProps.index,
            TEXTFIELD_TYPES.name,
          );
        }}
      />
      <AdminTextInput
        title={strings.admin.lastName}
        placeholder={strings.admin.lastName}
        value={props.itemProps.item.surname}
        onChangeText={newValue => {
          props.onFieldEdit(
            newValue,
            props.itemProps.index,
            TEXTFIELD_TYPES.surname,
          );
        }}
      />
      <AdminTextInput
        title={strings.admin.email}
        placeholder={strings.admin.email}
        value={props.itemProps.item.email}
        onChangeText={newValue => {
          props.onFieldEdit(
            newValue,
            props.itemProps.index,
            TEXTFIELD_TYPES.email,
          );
        }}
      />
      <RectangleImageButton
        image={theme.images.trashDark}
        onPress={() => props.onPressDelete(props.itemProps.item)}
        fullImage={false}
        backgroundColor={theme.colors.dirtyWhite}></RectangleImageButton>
    </View>
  );
});

export default ContactDataCell;
